import { CustomerModel, RequestFromType } from './CustomerModel';
import { AccountModel } from './AccountModel';
import { ProductModel } from './selfcareproducts';
import { DeviceCommission } from './DeviceCommission';
import { ActivationCommission } from './ActivationCommission';
import { OutletModel } from './OutletModel';


export interface PaymentModel    {
    RequestFrom: RequestFromType;
    Description: string;
    PortaOneReference: PortaOneReferenceInfo;
    Source: string;
    Customer: CustomerModel;
    AllocationCustomer: CustomerModel;
    PaymentAccount: AccountModel[];
    AllocationAccount: AccountModel[];
    Amount: number;
    CreditedAmount: number | null;
    OldBalance: number | null;
    ActualPaymentReceiptNumber: string;
    ReceiptNumber: string;
    TransactionReference: string;
    PortaOneActionType: PortaOneActionTypeInfo | null;
    Product: ProductModel;
    ExpirationExtension: boolean | null;
    OldBalanceExtension: boolean | null;
    IsEmailSent: boolean | null;
    IsSMSSent: boolean | null;
    Discount: DiscountInfo;
    Promotions: PromotionalInfo[];
    PaymentType: PaymentTypeInfo;
    IsReversal: boolean | null;
    NoofDays: number | null;
    Accessories: AccessoryInfo[];
    AdditionalAmount: number | null;
    AllocateAll: boolean | null;
    Location: string;
    Category: string;
    MDRMNRefNo: string;
    Origin: string;
    PaymentID: string | null;
    ExactAmount: boolean | null;
    DeviceCommission: DeviceCommission;
    ActivationCommission: ActivationCommission;
    Gateway: PaymentGateway;
    Outlet: OutletModel;
    NAVUpdateStatus: boolean | null;
    CreatedBy:string;
    CreatedDate:Date;
    DealerUserID:string;
    VAT:number;
     ProdVatPrice:number;
      VatPercentage: number;

    new(): PaymentModel;
}


export interface PaymentCyberPayV2Complete
{
    Message: string;
    IsSuccessful: boolean;
    paymentModel: PaymentModel;
}

export interface PaymentRequestModel    {
    PortaOneReference: PortaOneReferenceInfo;
    Source: string;
    Customer: CustomerModel;
    PaymentAccount: AccountModel;
    ActualPaymentReceiptNumber: string;
    ReceiptNumber: string;
    TransactionReference: string;
    Product: ProductModel;
    StartDate: Date | string;
    EndDate: Date | string;
    Limit: number;
    Agent: string;
    Location: string;
    Category: string;
    Origin: string;
    Dealer: string;
    OperatorCode: number;
    PaymentName: string;
    Partial: boolean | null;
}

export enum PaymentGateway { Cyberspace, Interswitch,  PayU,  Wallet,  Voucher,Transfer }

export interface PaymentBatchInfo
{
    MDN: string;
    NoofSubsription: number;
    ReceiptNumber: string;
    Balance: number;
    ExpirationDate: Date | string;
    ErrorMessage: string;
}
export interface PaymentBatchInfoModel
{
    Payments: PaymentBatchInfo[];
    RequestFrom: RequestFromType;
    Createdby: string;
    Password: string;
}

export interface DiscountInfo
{
    ID: number;
    Category: string;
    Type: DiscountValueType;
    Value: number;
}
export enum DiscountValueType { Percentage, Actual }
export enum PortaOneActionTypeInfo {
  
    ManualCharge,
  
    ManualPayment,
 
    ManualCredit,
 
    PromotionalCredit,
  
    ManualRefund
}

export enum PaymentTypeInfo {
    Payment,
    Adjustment,
    Allocation,
    Activation,
    Renewal,
    Accessory,
    Wallet,
    ExtraGB,
    AdditionalAccount,
    Commission,
    Promo,
    Credit,
    Loan,
    Compensation
}

export interface PortaOneReferenceInfo
{
    Type: PortaOneReferenceType;
    iXDR: string;
    iTransactionRef: string;
}

export enum PortaOneReferenceType {
    AccountRecord, CustomerRecord
}

export interface PromotionalInfo
{
    PromotionID: number;
    Category: string;
   // Type: ValueType;
    Value: number;
}

export interface AccessoryInfo    {
    IMEI: string;
    DeviceID: number;
    i_customer: number;
    DeviceIdentification: string;
    SNo: string;
    MAC: string;
    ModelNo: string;
    Name: string;
    Price: number;
    Count: number;
    discountValue: DiscountInfo;
    Active: boolean;
    NAVCode: string;
    NAVPrice: number;
    Promo_i_product: number;
}

export interface AccessoryBatchInfo
{
    DeviceName: string;
    ModelNo: string;
    SerialNo: string;
    Mac: string;
    IMEI: string;
    ErrorMessage: string;
}

export interface AccessoryBatchInfoModel
{
    Accessories: AccessoryBatchInfo[];
    RequestFrom: RequestFromType;
    Createdby: string;
    Password: string;
    OperatorCode: number;
}